import { ReactComponent as OfficialSiteIcon } from '../../assets/images/icon/ico-offical-site.svg';
import { ReactComponent as DeliveryIcon } from '../../assets/images/icon/ico-fast-delivery.svg';
import { ReactComponent as SecurePaymentIcon } from '../../assets/images/icon/ico-secure-payment.svg';
import { ReactComponent as CollectionIcon } from '../../assets/images/icon/ico-full-collection.svg';

// Data for the feature items
const featuresData = [
  {
    IconComponent: OfficialSiteIcon,
    title: 'OFFICIAL WEBSITE',
    description: 'The largest online selection of official Samsonite products including luggage, backpacks, bags and travel accessories.',
  },
  {
    IconComponent: DeliveryIcon,
    title: 'STANDARD DELIVERY',
    description: 'Standard delivery within 5-7 working days.',
  },
  {
    IconComponent: SecurePaymentIcon,
    title: 'SECURE PAYMENT',
    description: 'Secure Socket Layer (SSL) encryption makes every transaction safe and reliable.',
  },
  {
    IconComponent: CollectionIcon,
    title: 'FULL COLLECTION',
    description: 'One-stop shop for exploring the complete Samsonite collection online.',
  },
];

const WhyShopWithUs = () => {
  return (
    <section className="font-sans max-w-7xl mx-auto my-10 p-5 text-center">
      <h2 className="text-2xl font-bold mb-10 tracking-wider text-black">
        WHY SHOP WITH US?
      </h2>
      <div className="flex flex-col lg:flex-row divide-y lg:divide-y-0 lg:divide-x divide-gray-200">
        
        {/* Map over the data array to create each feature item */}
        {featuresData.map((feature, index) => (
          <div 
            key={index}
            className="flex-1 flex flex-col items-center p-8 lg:py-0"
          >
            <div className="mb-5">
              {/* Render the icon component and apply styling */}
              <feature.IconComponent className="h-12 w-12 text-gray-600" />
            </div>
            <h3 className="text-sm font-bold tracking-wide uppercase mb-2.5 text-black">
              {feature.title}
            </h3>
            <p className="text-sm leading-relaxed text-gray-600">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyShopWithUs;